import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Points, textSize } from '@styles';

export const PageTop = ({ title, description }) => {

  return (
    <TopWrap>
      <Title>{title}</Title>
      <Text>{description}</Text>
    </TopWrap>
  );
};

const TopWrap = styled.div``;
const Title = styled.h1`
  margin-bottom: 20px;
  ${textSize('page_header')};
  color: ${Colors.main_black};
  font-weight: 200;
  text-align: center;

  @media ${Points.laptop_wide} {
    margin-bottom: 30px;
  }
`;

const Text = styled.p`
  margin: 0 auto;
  max-width: 535px;
  text-align: center;

  @media ${Points.fullhd} {
    max-width: 650px;
  }
`;
